<template>
  <nav class="main-menu">
    <div class="container">
      <div class="logo">
        <router-link to="/">
          <img src="@/assets/images/arkayl_logo_clear.png" :alt="$t('logoAlt')">
        </router-link>
      </div>
      <ul class="menu-options">
        <li class="highlight has-sublist">
          <router-link to="/services">{{ $t('menuServices') }}</router-link>
          <div class="sublist col-3">
            <router-link to="/services" class="item">
              <img src="@/assets/images/icons/availability-svgrepo-com.svg" />
              <div>
                <h6 class="title">{{ $t('serviceListItemTitle_1') }}</h6>
                <p class="description">{{ $t('serviceListItemDescription_1') }}</p>
              </div>
            </router-link>

            <router-link to="/services" class="item">
              <img src="@/assets/images/icons/mobile-app-svgrepo-com.svg" />
              <div>
                <h6 class="title">{{ $t('serviceListItemTitle_2') }}</h6>
                <p class="description">{{ $t('serviceListItemDescription_2') }}</p>
              </div>
            </router-link>

            <router-link to="/services" class="item">
              <img src="@/assets/images/icons/host-record-svgrepo-com.svg" />
              <div>
                <h6 class="title">{{ $t('serviceListItemTitle_3') }}</h6>
                <p class="description">{{ $t('serviceListItemDescription_3') }}</p>
              </div>
            </router-link>

            <router-link to="/services" class="item">
              <img src="@/assets/images/icons/7x24h-svgrepo-com.svg" />
              <div>
                <h6 class="title">{{ $t('serviceListItemTitle_4') }}</h6>
                <p class="description">{{ $t('serviceListItemDescription_4') }}</p>
              </div>
            </router-link>

            <router-link to="/services" class="item">
              <img src="@/assets/images/icons/multiple-defenses-svgrepo-com.svg" />
              <div>
                <h6 class="title">{{ $t('serviceListItemTitle_5') }}</h6>
                <p class="description">{{ $t('serviceListItemDescription_5') }}</p>
              </div>
            </router-link>

            <router-link to="/services" class="item">
              <img src="@/assets/images/icons/system-settings-svgrepo-com.svg" />
              <div>
                <h6 class="title">{{ $t('serviceListItemTitle_6') }}</h6>
                <p class="description">{{ $t('serviceListItemDescription_6') }}</p>
              </div>
            </router-link>
          </div>
        </li>
        <li><router-link to="/about-us">{{ $t('menuAbout') }}</router-link></li>
        <li><router-link to="/case-studies">{{ $t('caseStudies') }}</router-link></li>
      </ul>
      <div class="header-links">
        <div class="language-section">
          <span class="language-select-icon"></span>
          <div class="sublist">
            <button @click="changeLanguage('en')"><span class="fi fi-gb"></span> {{ $t('langEnglish') }}</button>
            <button @click="changeLanguage('ro')"><span class="fi fi-ro"></span> {{ $t('langRomanian') }}</button>
            <button @click="changeLanguage('ru')"><span class="fi fi-ru"></span> {{ $t('langRussian') }}</button>
          </div>
        </div>
        <router-link class="primary-button" to="/contact">{{ $t('menuContact') }}</router-link>
      </div>
      <button class="menu-toggle" @click="$emit('toggle-sidebar')">
        <span class="menu-icon"></span>
      </button>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'AppHeader',

  data () {
    return {
      scrollHandler: null,
      lastScrollTop: 0
    }
  },

  methods: {
    changeLanguage (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('user-locale', locale)
      document.documentElement.setAttribute('lang', locale)
    },

    initializeHeaderBehavior () {
      if (this.scrollHandler) {
        window.removeEventListener('scroll', this.scrollHandler)
        this.scrollHandler = null
      }

      const header = document.querySelector('.main-menu')
      if (!header) return

      if (window.innerWidth > 1200) {
        this.lastScrollTop = window.pageYOffset || 0

        this.scrollHandler = () => {
          const currentScroll = window.pageYOffset || 0

          if (currentScroll > this.lastScrollTop && currentScroll > 100) {
            header.classList.add('hide')
          } else {
            header.classList.remove('hide')
          }

          this.lastScrollTop = currentScroll <= 0 ? 0 : currentScroll
        }

        window.addEventListener('scroll', this.scrollHandler)
      } else {
        header.classList.remove('hide')
      }
    }
  },

  mounted () {
    this.initializeHeaderBehavior()
    window.addEventListener('resize', this.initializeHeaderBehavior)
  },

  beforeUnmount () {
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler)
    }
    window.removeEventListener('resize', this.initializeHeaderBehavior)
  }
}
</script>
<style scoped>

.menu-toggle {
  background: none;
  border: none;
  cursor: pointer;
  display: block;
  width: 40px;
  height: 40px;
  position: relative;
  background-image: url(@/assets/images/icons/menu_24dp_000_FILL0_wght400_GRAD0_opsz24.svg);
  background-size: contain
}

@media(min-width: 1001px) {
  .menu-toggle {
    display: none;
  }
}

.main-menu {
  background-color: #F7F9FC;
  position: fixed;
  top: 10px;
  left: 10px;
  border-radius: 0 30px 0 30px;
  z-index: 999;
  transition: all .4s ease;
  opacity: 1;
  width: calc(100% - 20px);
  box-shadow: 0 0 15px #0001;
}

.main-menu.hide {
  transform: translateY(-120%);
  transition: all 0.4s ease;
  opacity: 0;
}

.main-menu .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  z-index: 1000;
  width: calc(100% - 40px);
}

.logo img {
  height: 80px;
}

.language-select-icon {
  display: block;
  position: relative;
  width: 30px;
  height: 30px;
  background: url(../assets/images/icons/language.svg);
  background-size: contain;
}

.language-section .sublist {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transition: all .2s ease;
  transform: translateY(10px);
  position: absolute;
  top: 95%;
  left: -40px;
  background-color: #fff;
  border-radius: 10px;
  padding: 10px;
}

.language-section:hover .sublist {
  opacity: 1;
  visibility: visible;
  pointer-events: all;
  transform: translate(0);
}

.menu-options li {
  display: inline;
  text-transform: uppercase;
  font-size: 18px;
  margin: 0;
}

.menu-options li a {
  color: #000;
  transition: all .2s ease;
}

.menu-options li.has-sublist a {
  padding: 15px;
  border-radius: 10px;
}

.menu-options li.has-sublist a:hover {
  background-color: #F7F9FC;
}

.menu-options li a img {
  width: 40px;
  height: auto;
}

.menu-options li:hover > a {
  color: var(--secondary-color);
}

.menu-options a {
  text-decoration: none;
  font-weight: bold;
}

.language-section {
  position: relative
}

.language-section .sublist {
  width: fit-content;
}

.language-section button {
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: none;
  border: none;
  width: 100%;
}

.language-section button:hover {
  background-color: #f0f0f0;
}

.language-section .fi {
  margin-right: 5px;
}

.menu-options, .header-links {
  display: none;
}

@media(min-width: 1001px) {
  .menu-options {
    list-style: none;
    display: flex;
    gap: 60px;
    margin: 0;
    padding: 0;
  }
  .header-links {
    display: flex;
    align-items: center;
    gap: 15px;
  }
}

@media(max-width: 768px) {
  .logo img {
    height: 60px;
  }
}

</style>
